var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#C52E3F;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assist_Outline",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.5,100.1c-27.6,0-50-22.4-50-50s22.4-50,50-50s50,22.4,50,50S78.1,100.1,50.5,100.1z M50.5,1.1 c-27,0-49,22-49,49s22,49,49,49s49-22,49-49S77.6,1.1,50.5,1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.1,41.8h-1c0-14.7-11.9-26.6-26.6-26.6S24,27.1,24,41.8h-1c0-15.2,12.4-27.6,27.6-27.6 C65.7,14.2,78.1,26.6,78.1,41.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.7,81.9v-1c14.4,0,20.1-5.1,20.1-18.2h1C76.8,76.3,70.7,81.9,55.7,81.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.6,62.6h-4.4c-3.3,0-6-2.7-6-6v-8.8c0-3.3,2.7-6,6-6h4.4L27.6,62.6L27.6,62.6z M23.2,42.8 c-2.8,0-5,2.2-5,5v8.8c0,2.8,2.2,5,5,5h3.4V42.8H23.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,62.6h-4.4V41.8h4.4c3.3,0,6,2.7,6,6v8.8C83.9,59.9,81.2,62.6,77.9,62.6z M74.4,61.6h3.4 c2.8,0,5-2.2,5-5v-8.8c0-2.8-2.2-5-5-5h-3.4V61.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.7,83.5h-8.3c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h8.3c1.2,0,2.1,0.9,2.1,2.1S55.8,83.5,54.7,83.5z  M46.4,80.3c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h8.3c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H46.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Assist_Red",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 50,
    cy: 50,
    r: 50
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.6,41.7h-1C76.6,27,64.7,15.1,50,15.1S23.4,27,23.4,41.7h-1c0-15.2,12.4-27.6,27.6-27.6 S77.6,26.5,77.6,41.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,81.8v-1c14.4,0,20.1-5.1,20.1-18.2h1C76.3,76.2,70.2,81.8,55.2,81.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,62.5h-4.4c-3.3,0-6-2.7-6-6v-8.8c0-3.3,2.7-6,6-6h4.4V62.5z M22.7,42.7c-2.8,0-5,2.2-5,5v8.8 c0,2.8,2.2,5,5,5h3.4V42.7H22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.3,62.5h-4.4V41.7h4.4c3.3,0,6,2.7,6,6v8.8C83.3,59.8,80.6,62.5,77.3,62.5z M73.9,61.5h3.4 c2.8,0,5-2.2,5-5v-8.8c0-2.8-2.2-5-5-5h-3.4V61.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.2,83.3h-8.3c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h8.3c1.2,0,2.1,0.9,2.1,2.1S55.3,83.3,54.2,83.3z  M45.8,80.2c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h8.3c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H45.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Connect_Outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.8,81.2H35.2c-3.3,0-6-2.7-6-6V24.8c0-3.3,2.7-6,6-6h29.7c3.3,0,6,2.7,6,6v50.5 C70.8,78.6,68.1,81.2,64.8,81.2z M35.2,19.8c-2.8,0-5,2.2-5,5v50.5c0,2.8,2.2,5,5,5h29.7c2.8,0,5-2.2,5-5V24.8c0-2.8-2.2-5-5-5 H35.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.7,70.8H33.3V29.2h33.3L66.7,70.8L66.7,70.8z M34.3,69.8h31.3V30.2H34.3V69.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 29.2,
    className: "st4",
    width: 1,
    height: 41.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 43.2,
    className: "st4",
    width: 33.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 55.8,
    className: "st4",
    width: 33.3,
    height: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWhite);
export default __webpack_public_path__ + "static/media/connect-white.e37696e3ec20fab3c025ed1ffe8377fb.svg";
export { ForwardRef as ReactComponent };